import React, { useEffect } from "react";
import "./landingpage.css";
import { companylogo, merchentpagelogo } from "../../assets/ImageExports";
import { Link, useNavigate } from "react-router-dom";

const Landingpage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  return (
    <div>
      <div className="bg-image_">
        <div className="container">
          <div className="button_container">
            <div>
              <div>
                <Link to="/otppage" state={{ member_type: 2 }}>
                  <button type="button" className="btn btn-light btn_stag">
                    <span className="image_root">
                      <img
                        src={companylogo}
                        className="icon_trak"
                        alt="Company Logo"
                      />
                    </span>
                    Registered as a company
                  </button>
                </Link>
              </div>
              <div>
                <Link to="/otppage" state={{ member_type: 4 }}>
                  <button type="button" className="btn btn-light btn_stag">
                    <span className="image_root">
                      <img
                        src={merchentpagelogo}
                        className="icon_trak"
                        alt="Merchant Logo"
                      />
                    </span>
                    Onboard as a merchant
                  </button>
                </Link>
              </div>
              <div className="button_home">
                <Link to="/loginscreen">
                  <button
                    type="button"
                    class="btn "
                    style={{ background: "#F97A00", color: "#ffffff" }}
                  >
                    Login
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landingpage;
